/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { MedictionProfileViewModel } from './MedictionProfileViewModel'; 

export function getMedicationProfileOptions(stayId: string, onSuccess?: (result: MedictionProfileViewModel) => void) {
	return queryOptions({
		queryKey: ['medication-profile', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/medicationprofiles/queries/getmedicationprofile/' + stayId;
			const resp = await axios.get<MedictionProfileViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}